var hideMessageAfter = ''
var discountBanner = document.querySelector('.info-banner--product-added')
function productAddedBanner() {
	if (!!discountBanner) {
		var hideMessageAttr = discountBanner.getAttribute('data-hide-message')

		if (!!hideMessageAttr) {
			hideMessageAfter = Number(hideMessageAttr)
		} else {
			hideMessageAfter = 3500;
		}
		var hideMessageAfterOpacity = hideMessageAfter - 200

		discountBanner.classList.remove("hidden");
		setTimeout(function () {
			discountBanner.style.opacity = 1;
		}, 500);

		setTimeout(function () {
			discountBanner.style.opacity = 0;
		}, hideMessageAfterOpacity);

		setTimeout(function () {
			discountBanner.classList.add("hidden");
	}, hideMessageAfter);
	}
}

if (window.location.pathname !== theme.routes.cartPage) {

	// document.addEventListener("cart:build", function() {
	// 	productAddedBanner() 
	// })

	document.addEventListener("ajaxProduct:added", function (e) { 

		productAddedBanner() 
	})
}